var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbol25210(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.943,
    height: 23.942,
    viewBox: "0 0 23.943 23.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ed-a{fill:none;}.ed-b{clip-path:url(#a);}.ed-c{fill:#707070;}.ed-d{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ed-a",
    width: 23.942,
    height: 23.943
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ed-b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "ed-c",
    cx: 11.971,
    cy: 11.971,
    rx: 11.971,
    ry: 11.971
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.385 5.587)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ed-d",
    d: "M385,201.823l3.192,3.232H385Zm5.587-6.345,3.192,3.192-4.806,5.622-3.175-3.228Zm1.664-1.771a1.569,1.569,0,0,1,2.139.333l.618.618a1.569,1.569,0,0,1,.333,2.139l-.986.986-3.09-3.09Zm0,0",
    transform: "translate(-385 -193.412)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol25210);
export default __webpack_public_path__ + "static/media/Symbol 25 – 210.907cca46c0b7d06dc093a1ddf83b6414.svg";
export { ForwardRef as ReactComponent };